import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardModule } from 'primeng/card';
import { SkeletonModule } from 'primeng/skeleton';

@Component({
  selector: 'app-tasks-stats-widget',
  standalone: true,
  imports: [CommonModule, CardModule, SkeletonModule],
  templateUrl: './tasks-stats-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TasksStatsWidget {
  count = input<number>(0);
  loading = input<boolean>(false);
}
